module.exports = __webpack_public_path__ + "static/chorus-1-7ebd71c399ba8825c7bde18d4c331c05.png";